// Config opé IPONE x ZONTES — Cleaning Kit acheté = Tour de cou offert
// Cohérent avec l'Automatic Discount Shopify "op-ipone-zontes-2026"

export const GIFT_PROMO = {
  slug: 'ipone-zontes-2026',

  // Opération France uniquement : les variant IDs ci-dessous n'existent que sur
  // checkout.ipone.com. Sur le store EU (checkout.eu.ipone.com) ni le produit
  // ni l'Automatic Discount ne sont configurés, donc le code reste inerte
  // naturellement (isKitVariant() retourne false).

  // Opé active du lundi 28/05/2026 (test staging) jusqu'au 01/09/2026 minuit (Europe/Paris)
  startDate: new Date('2026-05-28T00:00:00+02:00').getTime(),
  endDate: new Date('2026-09-01T23:59:59+02:00').getTime(),

  kitVariantIds: [
    'gid://shopify/ProductVariant/47613441016152',
  ],
  giftVariantId: 'gid://shopify/ProductVariant/57626501546367',

  // 'perOrder' = max 1 cadeau quelle que soit la qté de kits
  // 'perKit'   = 1 cadeau par kit
  qtyRule: 'perOrder',
};

export const GIFT_ATTRIBUTE_KEY = '_gift';

export const isPromoActive = (now = Date.now()) =>
  now >= GIFT_PROMO.startDate && now <= GIFT_PROMO.endDate;

export const isKitVariant = (variantId) =>
  GIFT_PROMO.kitVariantIds.includes(variantId);

export const isGiftLine = (line) =>
  (line?.customAttributes || []).some(
    (a) => a.key === GIFT_ATTRIBUTE_KEY && a.value === GIFT_PROMO.slug
  );

export const giftQtyForKits = (totalKitsInCart) => {
  if (totalKitsInCart <= 0) return 0;
  return GIFT_PROMO.qtyRule === 'perKit' ? totalKitsInCart : 1;
};

// Compte les kits présents dans le checkout (somme des quantités)
export const countKitsInCheckout = (checkout) => {
  const lines = checkout?.lineItems || [];
  return lines
    .filter((li) => isKitVariant(li.variant?.id))
    .reduce((sum, li) => sum + (li.quantity || 0), 0);
};

// Récupère la ligne gift dans le checkout, si elle existe
export const findGiftLine = (checkout) =>
  (checkout?.lineItems || []).find(isGiftLine);
